export class CategoryListState {
    sortColumn: number;
    sortDirection: 'asc' | 'desc';

	constructor() {
        this.sortColumn = 0;
        this.sortDirection = 'desc';
	}
};